import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { Tooltip } from 'components';

const styles = {
  root: {
    maxWidth: 500,
  },
};

const QuickHelp = ({ children, classes, link, placement, style }) => (
  <Tooltip
    classes={{ tooltip: classes.root }}
    placement={placement}
    tooltip={children}
  >
    <div
      style={{
        borderRadius: '50%',
        width: 25,
        height: 25,
        display: 'inline-block',
        textAlign: 'center',
        backgroundColor: 'gray',
        color: 'white',
        fontSize: 15,
        lineHeight: '25px',
        cursor: 'pointer',
        fontWeight: 'bold',
        ...style,
      }}
      className="d-sm-down-none"
    >
      {link ? <a href={link}>?</a> : '?'}
    </div>
  </Tooltip>
);

QuickHelp.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  link: PropTypes.string,
  placement: PropTypes.string,
  style: PropTypes.shape({}),
};

QuickHelp.defaultProps = {
  children: '',
  link: '',
  placement: '',
  style: {},
};

export default withStyles(styles)(QuickHelp);
